var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17q-.625 0-1.062-.438Q2 16.125 2 15.5v-11q0-.625.438-1.062Q2.875 3 3.5 3h13q.625 0 1.062.438Q18 3.875 18 4.5v11q0 .625-.438 1.062Q17.125 17 16.5 17Zm.896-2.979h4v-1.5h-4Zm7.729-1.521 3.542-3.542-1.063-1.062-2.479 2.479-1.063-1.063L10 10.375Zm-7.729-1.75h4v-1.5h-4Zm0-3.25h4V6h-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheckIcon);
export default __webpack_public_path__ + "static/media/fact-check-icon.ca927fddf3e21db8da6cf3b666d49b4e.svg";
export { ForwardRef as ReactComponent };